<template>
  <div class="container-fluid">
    <div class="container product-content-box">
      <h4>
        {{
          this.$store.getters
            .getWordLocale("txt_uretmek_ve_ihracat_uzamani")
            .replace("{1}", companyName)
        }}
      </h4>
    </div>
    <div class="container">
      <div class="d-sm-flex product-content-list row">
        <div v-for="(kw, i) in companyKeywords" :key="i" class="col-12 col-sm-3 ">
          <div
            v-if="i < 4"
            class="
              product-content-item mb-3"
          >
            <abbr>{{ i + 1 }}</abbr> <span>{{ toTitles(kw) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid pb-5">
    <div class="container">
      <div class="company-keyowrd-list">
        <a
          v-for="(kw, i) in companyKeywords"
          :key="i"
          v-show="i > 3 && i <= 10"
          href="javascript:;"
        >
         {{ i + 1 }} - {{ toTitles(kw) }}
        </a>

        <a
          v-for="(kw, i) in companyKeywords"
          :key="i"
          v-show="i > 10 && showAll"
          href="javascript:;"
        >
          {{ i + 1 }} - {{ toTitles(kw) }}
        </a>
      </div>

      <div class="container d-flex justify-content-center">
        <a
          v-show="companyKeywords.length > 10 && showAll == false"
          href="javascript:;"
          v-on:click="showAllKeywords()"
          class="company-keyword-show-all"
        >
          {{ toTitles(this.$store.getters.getWordLocale("txt_tumunu_goster")) }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["companyName", "companyKeywords"],
  data: function () {
    return {
      showAll: false,
    };
  },
  methods: {
    toTitles(s) {
        return s.toLowerCase();
    },
    showAllKeywords() {
      this.showAll = true;
    },
  },
  mounted() {},
};
</script>
